function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgLocalizacao = function SvgLocalizacao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M22.187 25.712l5.988 2.416-3.342-9.825-2.754-.9.31-.95 2.992.977a.5.5 0 01.318.314l3.774 11.095a.5.5 0 01-.66.625l-6.938-2.8-5.681 2.386a.5.5 0 01-.388 0l-5.68-2.386-6.939 2.8a.5.5 0 01-.66-.625L6.3 17.744a.5.5 0 01.318-.314l2.991-.977.31.95-2.753.9-3.342 9.825 5.988-2.416a.629.629 0 01.009-.058l1.219-6.205c.128-.654 1.11-.461.98.193l-1.218 6.204a.655.655 0 01-.003.017l5.2 2.184 5.2-2.184a.655.655 0 01-.003-.017l-1.219-6.204c-.128-.654.853-.847.981-.193l1.22 6.205.008.058zM19.75 9.618c0 2.102-1.677 3.81-3.75 3.81s-3.75-1.708-3.75-3.81c0-2.101 1.677-3.809 3.75-3.809s3.75 1.708 3.75 3.81zm-1 0c0-1.553-1.233-2.809-2.75-2.809s-2.75 1.256-2.75 2.81c0 1.552 1.233 2.808 2.75 2.808s2.75-1.256 2.75-2.809zm4.25 0c0 3.446-5.153 11.255-7 11.255-1.847 0-7-7.809-7-11.255C9 5.69 12.132 2.5 16 2.5s7 3.189 7 7.118zm-1 0c0-3.38-2.688-6.118-6-6.118-3.311 0-6 2.737-6 6.118 0 1.533 1.07 3.986 2.71 6.473 1.37 2.076 2.944 3.782 3.29 3.782.346 0 1.92-1.706 3.29-3.782C20.93 13.604 22 11.15 22 9.618z"
  }));
};
SvgLocalizacao.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgLocalizacao.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgLocalizacao;